const logger = window.console;

export default logger;
